window.IS_DEBUG = true;

window.trace_log = function (s) {
    if (window.IS_DEBUG) {
        console.log(s);
    }
};
